export default __webpack_public_path__ + "static/media/ic_sad_face.03ce53c3.svg";